var resizingActive = true;
// this is triggered in bl-scripts.js.liquid in switchLang()
function centerMainMenu() {
	var	navbarNav = $('ul.navbar-nav').css("width", "auto"),
		extraMargin = 2;

	if( ! resizingActive ) {
		navbarNav.css("visibility", "visible");
		return;
	}

	var collapse = $('#main-collapse').css("width", "auto"),
		width = navbarNav.width(),
		newWidth,
		indexPx;

	var paddingLeft = collapse.css("padding-left"),
		paddingRight = collapse.css("padding-right");

	indexPx = paddingLeft.indexOf("px");
	paddingLeft = parseInt(paddingLeft.substr(0, indexPx));
	indexPx = paddingRight.indexOf("px");
	paddingRight = parseInt(paddingRight.substr(0, indexPx));

	newWidth = width + extraMargin + paddingLeft + paddingRight;

	collapse.css({
		width: newWidth,
		"margin-left": "auto",
		"margin-right": "auto"
	});

	navbarNav.css("visibility", "visible");
}

enquire.register("(min-width: 768px", {
	match: function() {
		resizingActive = true;
	}
});
enquire.register("(max-width: 767px)", {
	match: function() {
		resizingActive = false;
	}
})
// make sure the menu is centered for both languages
$.subscribe("lang.switch", centerMainMenu);
// make sure menu resizes when having loaded a small page and sizing up the browser
$(window).on("resize", function(e) {
	centerMainMenu();
});